import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getAnchorIdsInText} from 'app/utils/initialize/getAnchorIdsInText';

export function addDeepLink(cId: string, text: string | undefined) {
    const anchorInText = getAnchorIdsInText(text);
    addScrollDeeplinkItemAction({cId, type: 'DEEPLINK', list: [...anchorInText, cId]});
}
